import _sfc_main from "./indexH5.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleOpenMemberControl, expression: "handleOpenMemberControl" }], ref: "memberItemContainerRef", staticClass: "member-item-container" }, [_c(_setup.MemberInfo, { attrs: { "show-state-icon": _setup.props.userInfo.isInRoom, "user-info": _setup.props.userInfo } }), _c(_setup.MemberControl, { directives: [{ name: "show", rawName: "v-show", value: _setup.showMemberControl && _setup.props.userInfo.isInRoom, expression: "showMemberControl && props.userInfo.isInRoom" }], attrs: { "show-member-control": _setup.showMemberControl, "user-info": _setup.props.userInfo }, on: { "on-close-control": _setup.handleDocumentTouchend } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "937b72bb"
);
const indexH5 = __component__.exports;
export {
  indexH5 as default
};
